import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './app/environments/environment';

// Silence application logs in production-like environments
// Keep only browser-generated warnings (lazy loading, CSP, etc.) and critical errors
if (environment.enableLogging === false) {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.debug = () => {};
  // Keep console.error for critical issues that need investigation
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
